import { getManagedTableData } from "app/pages/app-intelligence/app-analysis/pages/Engagement/components/helpers";
import { i18nFilter } from "app/filters/i18nFilter";
import { getAppleChartTableConfig } from "app/pages/app-intelligence/app-analysis/pages/Engagement/config/getUsersChartTableConfig";
import { AppEngagementOverviewTableWidget } from "./AppEngagementOverviewTableWidget";

export class AppEngagementOverviewTableIosWidget extends AppEngagementOverviewTableWidget {
    constructor() {
        super();
    }

    public override reduceRecords(records: unknown[]): unknown[] {
        const translate = i18nFilter();

        const managedRecords = getManagedTableData(getAppleChartTableConfig(), records, translate);

        return managedRecords;
    }
}

AppEngagementOverviewTableIosWidget.register();
